import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { IconDropUpMo, IconDropDownMo } from 'svgIcons/MotionPortalIcons';

import './_style.scss';
import { useContentSize } from 'sharedHooks';


const ExpandableComponent = ({
    id = '',
    onClick,
    open,
    noHeader,
    title,
    children,
    rightArrow,
    // expanded,
    // setIsExapnded = () => { },
    // setExpanded,
    disabled = false,
    kpiCount = 0,
    isExpanderInsideContent = false,
    headerClassName,
    collapsedIcon = <IconDropDownMo />,
    expandedIcon = <IconDropUpMo />,
    type = 'default'
}) => {
    const [expandableOpen, setExpandableStatus] = useState(false);

    const isDefaultType = type === 'default';
    const isOpen = isDefaultType ? expandableOpen : Boolean(open);

    const ref = useRef(null);
    const { height } = useContentSize(ref);

    const toggleExpandable = () => {
        if (!disabled) {
            setExpandableStatus(!expandableOpen);
        }
    };

    const handleClick = () => {
        if (!disabled) {
            toggleExpandable();
            if (onClick) {
                onClick();
            }
        }
    };

    const renderHeader = () =>
        !noHeader &&
        <button
            className={`header ${rightArrow ? 'right-arrow' : ''} ${headerClassName}`}
            key={id}
            onClick={handleClick}
            role='expandable-header'
        >
            <div className='header__left-pane'>
                {!isExpanderInsideContent &&
                    <div className='open-close-container'>
                        {isOpen ? expandedIcon : collapsedIcon}
                    </div>
                }
                <div className='title-content'>
                    {isExpanderInsideContent &&
                        <div className={`open-close-container ${isExpanderInsideContent ? 'enable-sticky' : ''}`}>
                            {isOpen ? expandedIcon : collapsedIcon}
                        </div>
                    }
                    {title}
                </div>
            </div>
            {kpiCount > 0 &&
                <div className='header__right-pane'>
                    <div className='count-indicator count-indicator--active'>{!isOpen ? `+ ${kpiCount}` : ''}</div>
                </div>
            }
        </button>;

    const renderContent = () => {
        return <div className='expandable-content' id={id} style={{ maxHeight: height }} >
            <div ref={ref} >
                {isOpen ? children : null}
            </div>
        </div>;

    };

    useEffect(() => {
        // force open flag to evaluate to boolean
        if (!!open !== expandableOpen) {
            toggleExpandable();
        }
    }, [open]);

    // useEffect(() => {
    //     if (!expanded && expandableOpen) {
    //         setExpandableStatus(false);
    //         setIsExapnded(false);
    //         setExpanded(false);
    //     }
    // }, [expanded]);

    return <div id={id} className='expandable-component' >
        {renderHeader()}
        {renderContent()}
    </div>;
};

ExpandableComponent.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    open: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func,
    noHeader: PropTypes.bool,
    disabled: PropTypes.bool,
    kpiCount: PropTypes.number,
    isExpanderInsideContent: PropTypes.bool
};

export default ExpandableComponent;
